var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-container"},[_c('HeaderComponent',{on:{"search-by-text":_vm.search_by_text}}),_c('router-view',{ref:"main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }